"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useIsChrome = () => {
  //Detects if the browser is chrome
  const [isChrome, setIsChrome] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (typeof window !== undefined) {
      setIsChrome(!!window.chrome);
    }
  }, []);
  return {
    isChrome
  };
};
var _default = useIsChrome;
exports.default = _default;